import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';

export interface ApprovePartItem {
  partNumber: string;
  category: string;
}

@Component({
  selector: 'app-approve-parts-modal',
  standalone: true,
  imports: [CommonModule, TranslocoDirective, TranslocoPipe],
  templateUrl: './approve-parts-modal.component.html',
  styleUrl: './approve-parts-modal.component.scss'
})
export class ApprovePartsModalComponent {
  @Input() workOrderNumber: string = '';
  @Input() parts: ApprovePartItem[] = [];

  isLoading = false;

  private modalInstance = inject(NgbActiveModal);

  onApprove(): void {
    this.modalInstance.close(true);
  }

  closeModal(): void {
    this.modalInstance.dismiss();
  }
}